import snippetspanel from "../../../../assets/images/docs/snippets/snippets.png";
import snippetfolder from "../../../../assets/images/docs/snippets/snippetfolder.png";
import addsnippet from "../../../../assets/images/docs/snippets/addsnippet.png";
import codesuggestions from "../../../../assets/images/docs/snippets/codesuggestions.png";
import cssselectors from "../../../../assets/images/docs/snippets/cssselectors.png";
import installsnippets from "../../../../assets/videos/blogs/pp29/installsnippet.mp4";
import * as React from 'react';
export default {
  snippetspanel,
  snippetfolder,
  addsnippet,
  codesuggestions,
  cssselectors,
  installsnippets,
  React
};